const AiVoiceAgentIcon = () => (
	<svg
		width="20"
		height="20"
		viewBox="0 0 20 20"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		stroke="currentColor"
	>
		{/* Microphone body */}
		<path
			d="M10 2C8.61929 2 7.5 3.11929 7.5 4.5V9.5C7.5 10.8807 8.61929 12 10 12C11.3807 12 12.5 10.8807 12.5 9.5V4.5C12.5 3.11929 11.3807 2 10 2Z"
			strokeWidth="1.8"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		{/* Microphone stand */}
		<path
			d="M10 12V17M10 17H7.5M10 17H12.5"
			strokeWidth="1.8"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		{/* Sound waves */}
		<path
			d="M15.5 8V9.5C15.5 12.8137 12.8137 15.5 10 15.5C7.18629 15.5 4.5 12.8137 4.5 9.5V8"
			strokeWidth="1.8"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		{/* AI sparkle top */}
		<path
			d="M14.5 2L15 3.5L16.5 4L15 4.5L14.5 6L14 4.5L12.5 4L14 3.5L14.5 2Z"
			fill="currentColor"
			stroke="none"
		/>
		{/* AI sparkle small */}
		<path
			d="M17 4.5L17.25 5L17.75 5.25L17.25 5.5L17 6L16.75 5.5L16.25 5.25L16.75 5L17 4.5Z"
			fill="currentColor"
			stroke="none"
		/>
	</svg>
);

export default AiVoiceAgentIcon;
